<template>
	<div>
		<div>
			<div class="bold-text" v-if="isOnlyPromoBonus() && buyInOfferSelected">
				<p class="buy-in-details">{{ languageStrings.cashBuys }}  <span class="italic-font">{{ systemCurrencyTool.currencyInfo.symbol }}{{ fromPlayerCashCOC }}</span> {{ languageStrings.and}} 
					{{ languageStrings.recieve }}  <span class="italic-font">{{ systemCurrencyTool.formatCurrency(potentialRegularCreditEarned, systemCurrencyTool.displayType.minorWholeOrFull) }}</span> {{ languageStrings.inCashableCredits }} {{ languageStrings.and }}
				 	<span class="italic-font">{{ systemCurrencyTool.formatCurrency(potentialPromoCreditsEarned,systemCurrencyTool.displayType.minorWholeOrFull) }}</span> {{ languageStrings.inRestrictedPromoCredits }}
				</p>
			</div>
			<div class="input-section" v-if="buyInOfferSelected">
				<div id="fromPlayerCashCOC">
					<span class="limit-text" v-if="restrictedNeedsMoreInfo && !sameMinAndMax">
						{{ languageStrings.buyInLimited }}:
						{{
							systemCurrencyTool.formatCurrency(
								findMaxForRange(),
								systemCurrencyTool.displayType.minorOrFull
							)
						}}
					</span>
					<!-- <span v-if="buyInOffer.remainingLimitCOC == null">
						{{ languageStrings.buyInLimited }}:
						{{
							systemCurrencyTool.formatCurrency(
								webPayOptions.taxAmlRestrictions.buyInThresholdCOC -1,
								systemCurrencyTool.displayType.minorOrFull
							)
						}}
					</span>
					<span v-if="buyInOffer.remainingLimitCOC != null">
						{{ languageStrings.yourRemainingLimit }}:
						{{ systemCurrencyTool.formatCurrency(
								buyInOffer.remainingLimitCOC,
								systemCurrencyTool.displayType.minorOrFull
							) 
						}}
					</span> -->
					<span>
						<input
							type="text"
							name="displayCOC"
							v-model="fromPlayerCashCOC"
							:placeholder="buyInOffer.minimumCOC"
							autocomplete="off"
							id="currency"
						/>
						<span v-if="!systemCurrencyTool.currencyInfo.doesSymbolGoInFront">{{
							systemCurrencyTool.currencyInfo.symbol
						}}</span>
					</span>
					<span v-if="!sameMinAndMax">
						<span class="currancy-symbol">{{ systemCurrencyTool.currencyInfo.symbol }}</span>
						<input
							type="range"
							name="displayCOC"
							:min="buyInOffer.minimumCOC"
							:max="findMaxForRange()"
							v-model="fromPlayerCashCOC"
							autocomplete="off"
						/>
						<span class="currancy-symbol"
							>{{ systemCurrencyTool.currencyInfo.symbol }}{{ systemCurrencyTool.currencyInfo.symbol
							}}{{ systemCurrencyTool.currencyInfo.symbol }}</span
						>
					</span>
				</div>
				<div v-if="isOnlyPromoBonus()" style="text-align: center;">
					<span>
						<label>{{ languageStrings.yourGetting }}
							<span class="welcome-bonus-text inline-display italic-font">
								{{ systemCurrencyTool.formatCurrency(totalCreditsEarned,systemCurrencyTool.displayType.minorWholeOrFull) }}
							</span> {{ languageStrings.creditsExclamation }}
						</label>
						<span v-if="!systemCurrencyTool.currencyInfo.doesSymbolGoInFront">{{
							systemCurrencyTool.currencyInfo.symbol
						}}</span>
					</span>
				</div>
				<div v-if="!sameMinAndMax">
					<div class="row">
						<div class="column">
							<button
						class="btn add-in-btn encore-price-button"
						@click="addMoneyToInput(50)"
						:disabled="
							restrictedNeedsMoreInfo &&
							checkForDisablingAddingFundsButtons(50)
						"
					>
								<span v-if="systemCurrencyTool.currencyInfo.doesSymbolGoInFront">+{{
									systemCurrencyTool.currencyInfo.symbol
								}}50</span>
								
								<span v-if="!systemCurrencyTool.currencyInfo.doesSymbolGoInFront">{{
									systemCurrencyTool.currencyInfo.symbol
								}}</span>
							</button>
						</div>
						<div class="column">
							<button
						class="btn add-in-btn encore-price-button"
						@click="addMoneyToInput(100)"
						:disabled="
							restrictedNeedsMoreInfo &&
							checkForDisablingAddingFundsButtons(100)
						"
					>
								<span v-if="systemCurrencyTool.currencyInfo.doesSymbolGoInFront">+{{
									systemCurrencyTool.currencyInfo.symbol
								}}100</span>
								
								<span v-if="!systemCurrencyTool.currencyInfo.doesSymbolGoInFront">{{
									systemCurrencyTool.currencyInfo.symbol
								}}</span>
							</button>
						</div>
					</div>
					<div class="row">
						<div class="column">
							<button
						class="btn add-in-btn encore-price-button"
						@click="addMoneyToInput(200)"
						:disabled="
							restrictedNeedsMoreInfo &&
							checkForDisablingAddingFundsButtons(200)
						"
					>
								<span v-if="systemCurrencyTool.currencyInfo.doesSymbolGoInFront">+{{
									systemCurrencyTool.currencyInfo.symbol
								}}200</span>
								
								<span v-if="!systemCurrencyTool.currencyInfo.doesSymbolGoInFront">{{
									systemCurrencyTool.currencyInfo.symbol
								}}</span>
							</button>
						</div>
						<div class="column">
							<button
						class="btn add-in-btn encore-price-button"
						@click="addMoneyToInput(500)"
						:disabled="
							restrictedNeedsMoreInfo &&
							checkForDisablingAddingFundsButtons(500)
						"
					>
								<span v-if="systemCurrencyTool.currencyInfo.doesSymbolGoInFront">+{{
									systemCurrencyTool.currencyInfo.symbol
								}}500</span>
								
								<span v-if="!systemCurrencyTool.currencyInfo.doesSymbolGoInFront">{{
									systemCurrencyTool.currencyInfo.symbol
								}}</span>
							</button>
						</div>
					</div>
				</div>
				<div id="select-container">
					<!-- <span>{{ languageStrings.selectProvider }}</span> -->
					 <span>{{ languageStrings.paymentType }}</span>
					<select :title="languageStrings.selectProvider" class="curved-border encore-color" v-model="provider" id="paymentOptions">
						<option v-for="(item, index) in paymentOptions" :key="index" :value="item">
							{{ item.key }}
						</option>
					</select>
				</div>
				<!-- providerName in each of these was provider before in these cash ins -->
				<NuveiCashIn
					v-if="webPayOptions?.nuvei && providerName === 'Nuvei'"
					:playerState="playerState"
					:webPayOptions="webPayOptions"
					:systemCurrencyTool="systemCurrencyTool"
					:buyInOffer="buyInOffer"
					:languageErrorStrings="languageErrorStrings"
					:languageStrings="languageStrings"
					:fromPlayerCashCOC="fromPlayerCashCOC"
					:providerName="providerName"
					:restrictedNeedsMoreInfo="restrictedNeedsMoreInfo"
					:paymentMethodCode="paymentMethodCode"
					:playerLimit="playerLimit"
					:hasBeenBlockedForBuyInAndCashOut="hasBeenBlockedForBuyInAndCashOut"
				/>
				<!-- providerName in each of these was provider before in these cash ins -->
				<ConektaCashIn
					v-if="webPayOptions?.conekta && providerName === 'Conekta'"
					:playerState="playerState"
					:webPayOptions="webPayOptions"
					:systemCurrencyTool="systemCurrencyTool"
					:buyInOffer="buyInOffer"
					:languageErrorStrings="languageErrorStrings"
					:languageStrings="languageStrings"
					:fromPlayerCashCOC="fromPlayerCashCOC"
					:providerName="providerName"
					:restrictedNeedsMoreInfo="restrictedNeedsMoreInfo"
					:paymentMethodCode="paymentMethodCode"
					:playerLimit="playerLimit"
					:hasBeenBlockedForBuyInAndCashOut="hasBeenBlockedForBuyInAndCashOut"
				/>
				<!-- providerName in each of these was provider before in these cash ins -->
				<DirectaCashIn
					v-if="webPayOptions?.directa && providerName === 'Directa'"
					:playerState="playerState"
					:webPayOptions="webPayOptions"
					:systemCurrencyTool="systemCurrencyTool"
					:buyInOffer="buyInOffer"
					:languageErrorStrings="languageErrorStrings"
					:languageStrings="languageStrings"
					:fromPlayerCashCOC="fromPlayerCashCOC"
					:providerName="providerName"
					:restrictedNeedsMoreInfo="restrictedNeedsMoreInfo"
					:paymentMethodCode="paymentMethodCode"
					:playerLimit="playerLimit"
					:hasBeenBlockedForBuyInAndCashOut="hasBeenBlockedForBuyInAndCashOut"
					
				/>
			</div>
		</div>
	</div>
</template>

<script>
import sharedScripts from "@/dependencies/sharedScripts";
import NuveiCashIn from "@/components/NuveiCashIn";
import ConektaCashIn from "@/components/ConektaCashIn";
import DirectaCashIn from "@/components/DirectaCashIn";
import { onBeforeUnmount } from "vue";
import router from "@/router";

export default {
	name: "CommitBuyInOffer",
	components: {
		NuveiCashIn,
		ConektaCashIn,
		DirectaCashIn,
	},
	props: {
		buyInOfferSelected: Boolean,
		playerState: Object,
		buyInOffer: Object,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		webPayOptions: Object,
		isMobile: Boolean,
		restrictedNeedsMoreInfo: Boolean,
		hasBeenBlockedForBuyInAndCashOut: Boolean
	},
	data() {
		return {
			activeSession: this.session.get(),
			status: Object.assign({}, this.globalStatus),
			currencyInfo: this.playerState.currencyInfo,
			systemCurrencyInfo: this.systemCurrencyTool.currencyInfo,
			fromPlayerCashCOC: this.buyInOffer.minimumCOC,
			displayCOC: 0,
			regularAU: 0,
			buyIn: {
				cashierBankId: 0,
				playerUserId: "",
				accountAccessCode: 0,
				buyInOfferId: 0,
				fromPlayerCashCOC: 0,
			},
			transactionReport: {},
			buyInTransactionDetails: {},
			currencyInfo: this.playerState.currencyInfo,
			systemCurrencyInfo: this.systemCurrencyTool.currencyInfo,
			systemMinorOrFull: this.systemCurrencyTool.displayType.minorOrFull,
			systemFull: this.systemCurrencyTool.displayType.full,
			serverBusy: false,
			busyText: "",
			transaction: {},
			nuveiResult: {},
			playerFunds: {},
			transactionResult: {},
			paymentOptions: [],
			provider: "",
			paymentMethodCode: "",
			potentialPromoCreditsEarned: 0,
			potentialRegularCreditEarned:0,
			welcomeBackBonusMax: 0,
			onlyShowCardOption: false,
			sameMinAndMax:false,
			totalCreditsEarned:0,
			providerName:"",
			playerLimit:0,
			previousFromPlayerCashCOC: this.buyInOffer.minimumCOC
		};
	},
	watch: {
		buyInOfferSelected() {
			if (!this.buyInOfferSelected){
				this.fromPlayerCashCOC = this.webPayOptions.isEmailVerified ? this.buyInOffer.minimumCOC : 0;
			} 
			this.fromPlayerCashCOC = this.webPayOptions.isEmailVerified ? this.buyInOffer.minimumCOC : 0;
			this.potentialPromoCreditsEarned = this.fromPlayerCashCOC *(this.buyInOffer.creditPromoAUPerCashCOC/100);
			this.potentialRegularCreditEarned = this.fromPlayerCashCOC * (this.buyInOffer.creditRegularAUPerCashCOC/100);
			this.totalCreditsEarned = this.potentialRegularCreditEarned + this.potentialPromoCreditsEarned;

			//console.log("this is the total credits earned", this.totalCreditsEarned);
		},
		fromPlayerCashCOC() {
			if(Number.isNaN(this.fromPlayerCashCOC)) this.fromPlayerCashCOC = this.previousFromPlayerCashCOC;
			
			this.fromPlayerCashCOC = Number(this.fromPlayerCashCOC);

			if(!Number.isNaN(this.fromPlayerCashCOC)) this.previousFromPlayerCashCOC = this.fromPlayerCashCOC;
			
			//this.potentialPromoCreditsEarned = this.fromPlayerCashCOC *1.5;
			this.updateFromPlayerCashCoC();
		},
		provider() {
			if(typeof(this.provider) == "object"){
				this.paymentMethodCode = this.provider.providerMethodCode;
				//this.provider = this.provider.provider;
				this.providerName = this.provider.provider
			}		
		},
		potentialPromoCreditsEarned() {
			this.potentialPromoCreditsEarned = Number(this.fromPlayerCashCOC*(this.buyInOffer.creditPromoAUPerCashCOC/100));
			this.totalCreditsEarned = this.potentialRegularCreditEarned + this.potentialPromoCreditsEarned;
			if(this.isOnlyPromoBonus()){
				let buyInAndPromo = {
					fromPlayerCashCOC:this.fromPlayerCashCOC,
					potentialPromoCreditsEarned: this.potentialPromoCreditsEarned,
					regularCreditEarned: this.potentialRegularCreditEarned
				}
				this.eventBus.emit("buyInAndPromoAmount", buyInAndPromo);
			}
		},
		totalCreditsEarned(){
			this.totalCreditsEarned = Number(this.totalCreditsEarned);
		},
		hasBeenBlockedForBuyInAndCashOut() {
			//console.log("in commit buy in offer commit buy in offer", this.hasBeenBlockedForBuyInAndCashOut);
		}
	},
	created() {
		//This field was only created below for one of the releases and will be removed when that changes 6/10/25
		this.onlyShowCardOption = true;
		this.getPaymentOptions();
		if(this.isOnlyPromoBonus())this.welcomeBackBonusMax = this.buyInOffer.maximumCOC / (this.buyInOffer.creditPromoAUPerCashCOC/100);
		if(this.buyInOffer.minimumCOC == this.buyInOffer.maximumCOC) this.sameMinAndMax= true;
		this.playerLimit = this.findMaxForRange();
	},
	methods: {
		getPaymentOptions() {
			let webPayKeys = this.webPayOptions.buyInPaymentMethods;
			webPayKeys.forEach((buyInsPayment) => {

				// //This if check was only created below for one of the releases and will be removed when that changes 
				// // the commented out code below is the original flow of the buy in payments 6/10/25
				// if(this.onlyShowCardOption && buyInsPayment.key == this.languageStrings.creditCard || buyInsPayment.key == "CreditCard"){

				// 	buyInsPayment.key = this.checkTranslationPaymentOption(buyInsPayment.key);
				// 	this.paymentOptions.push(buyInsPayment);
				// } 

				buyInsPayment.key = this.checkTranslationPaymentOption(buyInsPayment.key);
				if(buyInsPayment.key == "Pagar con Tarjeta" ){
					this.provider = buyInsPayment;
				}
				this.paymentOptions.push(buyInsPayment);
	
			});
			if(this.paymentOptions.length === 0) {
				this.status.ok = false;
				this.status.message = this.languageErrorStrings.noPaymentMethods;
				this.eventBus.emit("updateStatus", this.status);
			}
		},
		addMoneyToInput(amount) {
			let fromPlayer = Number(this.fromPlayerCashCOC) + amount;
			if (fromPlayer > this.buyInOffer.maximumCOC) return;
			this.fromPlayerCashCOC = fromPlayer;
		},
		updateFromPlayerCashCoC() {
			if(this.potentialPromoCreditsEarned > this.buyInOffer.maximumCOC && this.fromPlayerCashCOC > this.buyInOffer.maximumCOC) return;
			this.potentialPromoCreditsEarned = Number(this.fromPlayerCashCOC *(this.buyInOffer.creditPromoAUPerCashCOC/100));
			this.potentialRegularCreditEarned = this.fromPlayerCashCOC * (this.buyInOffer.creditRegularAUPerCashCOC/100);
		},

		checkTranslationPaymentOption(buyInsPaymentName) {

			let paymentTranslationChange = buyInsPaymentName;

			if(buyInsPaymentName === "CreditCard"){
				paymentTranslationChange = this.languageStrings.creditCard;
			}
			if(buyInsPaymentName ==="OxxoPay"){
				paymentTranslationChange = this.languageStrings.oxxoPay;
			}
			if(buyInsPaymentName === "7Eleven"){
				paymentTranslationChange = this.languageStrings.sevenEleven;
			}
			if(buyInsPaymentName === "ToditoCash"){
				paymentTranslationChange = this.languageStrings.toditoCash;
			}
			if(buyInsPaymentName === "PayNet"){
				paymentTranslationChange = this.languageStrings.payNet;
			}
			if(buyInsPaymentName === "BancoAzteca"){
				paymentTranslationChange = this.languageStrings.bancoAzteca;
			}
			if(buyInsPaymentName === "FarmaciasDelAhorro"){
				paymentTranslationChange = this.languageStrings.farmaciasDelAhorro;
			}
			if(buyInsPaymentName === "BodegaAurrera"){
				paymentTranslationChange = this.languageStrings.bodegaAurrera;
			}
			if(buyInsPaymentName === "FarmaciaBenavides"){
				paymentTranslationChange = this.languageStrings.farmaciaBenavides;
			}
			if(buyInsPaymentName === "SamsClub"){
				paymentTranslationChange = this.languageStrings.samsClub;
			}
			if(buyInsPaymentName === "BancaMifel"){
				paymentTranslationChange = this.languageStrings.bancaMifel;
			}
			if(buyInsPaymentName === "RappiPay"){
				paymentTranslationChange = this.languageStrings.rappiPay;
			}
			if(buyInsPaymentName === "CirculoK"){
				paymentTranslationChange = this.languageStrings.circuloK;
			}

			return paymentTranslationChange;
		},

		findMaxForRange() {
			let max = 0;

			if(!this.webPayOptions.isEmailVerified) return max;

			if(this.isOnlyPromoBonus()) max= this.welcomeBackBonusMax;

			else max= this.buyInOffer.maximumCOC;
			
			if(this.restrictedNeedsMoreInfo && this.webPayOptions.taxAmlRestrictions.buyInThresholdCOC-1 < max){
				max = this.webPayOptions.taxAmlRestrictions.buyInThresholdCOC-1;
			} 
			// if(max > this.buyInOffer.remainingLimitCOC) max = this.buyInOffer.remainingLimitCOC; 
			// console.log("this is the max", this.welcomeBackBonusMax);

			return max;
		},

		findMaxForPromos() {
			let max = 0;
			if(this.restrictedNeedsMoreInfo) max = (this.webPayOptions.taxAmlRestrictions.buyInThresholdCOC-1)*(this.buyInOffer.creditPromoAUPerCashCOC/100);
			
			else max = this.welcomeBackBonusMax * (this.buyInOffer.creditPromoAUPerCashCOC/100);
			
			return max;
		},
		
		checkForDisablingAddingFundsButtons(amount) {
			if(this.fromPlayerCashCOC + amount > this.webPayOptions.taxAmlRestrictions.buyInThresholdCOC-1 || this.fromPlayerCashCOC + amount > this.findMaxForRange()) return true;
			return false;
		},

		isOnlyPromoBonus() {
			return this.buyInOffer.creditPromoAUPerCashCOC > 0;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-section {
	width: 100%;
	align-items: center;
}

.input-section span {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.input-section input {
	max-width: 90%;
	border-radius: 22px;
	text-align: center;
	font-size: 29px;
	color: #6305c9;
}

.buy-in-btn {
	/* background: linear-gradient(to right,blue, purple,#FA5F55); */
	/* background: white; */
	/* -webkit-text-fill-color: transparent; */
	/* color:#6305C9 !important; */
	background-clip: text;
	margin: 5px auto;
	width: 12vw;
	height: 4.5vh;
	font-weight: bolder;
	overflow-wrap: break-word;
}

button {
	display: block;
}

.column {
	flex: 1;
}

.row {
	display: flex;
}

.add-in-btn {
	display: flex;
	background-image: none;
}

div#fromPlayerCashCOC {
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
}

.currancy-symbol {
	padding: 0 5px;
	font-size: large;
}

/* #fromPlayerCashCOC input {
	width: 10em;
} */

#fromPlayerCashCOC span span {
	justify-content: end;
	width: 2em;
}

input[type="range"]::-webkit-slider-thumb {
	-webkit-appearance: none;
	cursor: pointer;
	background: #5d3fd3;
	border-radius: 50%;
	height: 20px;
	width: 20px;
}

input[type="range"]::-moz-range-thumb {
	background: #5d3fd3;
	height: 15px;
	width: 15px;
}

.button-container {
	background: white;
	border-radius: 15px;
	width: 12vw;
	margin-left: auto;
	margin-right: auto;
}

/* .button-container:hover {
	width: 12.7vw;
} */

button.btn:disabled {
	background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3)) !important;
	color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3)) !important;
	border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3)) !important;
}

button.btn:disabled {
	background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3)) !important;
	color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3)) !important;
	border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3)) !important;
}

#select-container {
	display: flex;
	padding: 15px;
}

.curved-border {
	height: 40px;
	width: 110px;
	padding-left: 5px;
}

.adjust-option {
	margin-left: 5px;
}

input:focus {
	outline: none;
	border: none;
}

select:focus {
	outline: none;
	border: none;
}

.welcome-bonus-text {
	color: #F74D4D !important;
	font-size: 29px;
	font-weight: bold;
}

.italic-font{
	font-style: italic;
}

.inline-display {
	display: inline !important;
}

.buy-in-details {
	text-align: center;
	font-size: smaller;
}
.limit-text {
	font-size: 70%;
}
@media (max-width: 1065px) and (min-width: 769px) {
	.buy-in-btn {
		width: 17vw;
	}
	.button-container {
		width: 17vw;
	}
	/* .button-container:hover {
		width: 18vw;
	} */
	
}

@media (max-width: 768px) {
	.input-section input {
		height: 45px;
		text-align: center;
		font-size: 35px;
		color: #46289b;
		max-width: 300px;
	}
	.button-container {
		background: white;
		border-radius: 15px;
		width: 31vw;
	}

	/* .button-container:hover {
		width: 33vw;
	} */

	.buy-in-btn {
		width: 31vw;
		padding: 5px;
	}

	.limit-text {
		/* margin-left: 5%; */
		margin-right: auto;
		font-size: x-small;
	}
}
</style>
